import { useOpenWithFaireStore } from "@faire/retailer/stores/domain/OpenWithFaireStore";

import { useFormattedTerms } from "./useFormattedTerms";

export const useFormattedOfferedMaxTerms = () => {
  const { offeredMaxTerms } = useOpenWithFaireStore(["offeredMaxTerms"]);
  return useFormattedTerms(offeredMaxTerms);
};
